export default function Footer() {
  return (
    <>
      <section className="bg-background-50">
        <div className="mx-auto max-w-[1200px] px-4 py-12 md:px-6 md:py-14">
          <div className="flex flex-col items-start justify-between gap-6 rounded-lg bg-primary-500 p-6 md:p-9 lg:flex-row lg:items-center">
            <div>
              <h2 className="font-heading text-2xl font-black text-background-50 md:text-3xl">
                今天又有什么料？上 5看料 抢先看。
              </h2>
              <p className="mt-2 text-sm text-primary-100">
                蹲更新、追更 5看料 最新爆料与速递，不错过任何高能瞬间。
              </p>
            </div>
            <div className="flex shrink-0 flex-col gap-3 sm:flex-row">
              <button
                type="button"
                className="inline-flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md bg-background-50 px-6 py-3 text-sm font-bold text-primary-700 transition-colors hover:bg-accent-100"
              >
                <i className="ri-arrow-down-circle-fill text-accent-600" />
                下载 5看料 App
              </button>
              <button
                type="button"
                className="inline-flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md border border-primary-300 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-400"
              >
                订阅每日新料
              </button>
            </div>
          </div>
        </div>
      </section>

      <footer className="border-t border-background-200 bg-background-100">
        <div className="mx-auto max-w-[1200px] px-4 py-10 md:px-6">
          <div className="flex flex-col justify-between gap-6 sm:flex-row sm:items-start">
            <div className="max-w-sm">
              <a href="#top" className="flex items-center gap-2">
                <span className="flex h-8 w-8 items-center justify-center rounded-md bg-primary-500 text-base font-black text-background-50">
                  5
                </span>
                <span className="font-heading text-xl font-black text-foreground-950">看料</span>
              </a>
              <p className="mt-3 text-xs leading-relaxed text-foreground-600">
                蹲料更新就上5看料，同步5看料最新爆料与速递内容，抢先看热门新料，第一时间掌握5看料更新动态。
              </p>
            </div>
            <div className="flex gap-10">
              <div>
                <h4 className="text-xs font-bold text-foreground-950">看料功能</h4>
                <ul className="mt-3 space-y-2 text-xs text-foreground-600">
                  <li><a href="#tracking" className="hover:text-primary-700">追更话题墙</a></li>
                  <li><a href="#scoop" className="hover:text-primary-700">最新爆料</a></li>
                  <li><a href="#flash" className="hover:text-primary-700">速递快讯</a></li>
                  <li><a href="#peek" className="hover:text-primary-700">抢先看预告</a></li>
                </ul>
              </div>
              <div>
                <h4 className="text-xs font-bold text-foreground-950">站点导航</h4>
                <ul className="mt-3 space-y-2 text-xs text-foreground-600">
                  <li><a href="#top" className="hover:text-primary-700">关于我们</a></li>
                  <li><a href="#wall" className="hover:text-primary-700">高能合集</a></li>
                  <li><a href="#top" className="hover:text-primary-700">帮助中心</a></li>
                  <li><a href="#top" className="hover:text-primary-700">意见反馈</a></li>
                </ul>
              </div>
            </div>
          </div>
          <div className="mt-8 flex flex-col items-start justify-between gap-2 border-t border-background-200 pt-5 sm:flex-row sm:items-center">
            <p className="text-[11px] text-foreground-500">© 2026 5看料 · 本站内容仅为界面演示，不构成真实爆料与新闻。</p>
            <div className="flex items-center gap-3 text-[11px] text-foreground-500">
              <a href="#top" className="hover:text-foreground-800">用户协议</a>
              <span>/</span>
              <a href="#top" className="hover:text-foreground-800">隐私政策</a>
              <span>/</span>
              <a href="#top" className="hover:text-foreground-800">联系客服</a>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}